import { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  actions,
  isFetchingProduct,
  getFetchProductFailure,
  isSuccessFetchProduct,
  getCurrentProduct
} from "../modules/market";

export default function useFetchProduct({ dealerId, productId }) {
  const loading = useSelector(isFetchingProduct);
  const failure = useSelector(getFetchProductFailure);
  const success = useSelector(isSuccessFetchProduct);
  const product = useSelector(getCurrentProduct);

  const dispatch = useDispatch();
  const fetchProduct = useCallback(
    ({ dealerId, productId }) => {
      dispatch(actions.fetchProduct({ dealerId, productId }));
    },
    [dispatch]
  );

  useEffect(() => {
    if (dealerId) {
      fetchProduct({ dealerId, productId });
    }
    return () => {
      dispatch(actions.resetState([]));
    };
  }, [dealerId, dispatch, fetchProduct, productId]);

  return {
    loading,
    failure,
    success,
    product
  };
}
